<template>
    <div>
        <div v-if="0 < catalogMessages.length" class="d-flex flex-column gap-3 mb-3">
            <div v-for="(catalogMessage, index) in catalogMessages"
                 v-html="catalogMessage"
                 :key="'cm_'+index"
                 class="home-catalog-message"></div>
        </div>

        <categories-list :categories="categories" :grouping="grouping"/>
    </div>
</template>

<script>

    import CategoriesList from "@/components/categories/CategoriesList";

    export default {
        name: "ViewsHomeTypeCategories",
        components: {
            CategoriesList
        },
        props: {
            categories: {
                type: Array,
                required: true
            },
            grouping: {
                type: String,
                required: true
            },
            catalogMessages: {
                type: Array
            }
        }
    }
</script>